import moment from 'moment'
import React from 'react'
import {Button, Card, Col, Drawer, Form, Icon, notification, Row, Table} from 'antd'
import _ from 'lodash'

import {FormUtils as GetAllFormFields} from 'sz-react-utils'
import {hideLoader, showLoader} from '../../modules/actions'
import Request from '../../request'
import {connect} from 'react-redux'
import styles from '../../containers/Desk/counselling/all/styles.less'
import {RightsWrapper} from './utils'

@Form.create()
class listInvoiceFollowUp extends React.Component {
    state = {
        generatedInvoice: {},
        visible: true,
        childrenDrawer: false,
        templateArr: [],
        arr: [],
        loading: false,
        formData: {},
        followUpObject:[]
    }

    loadInvoiceDetail = async() => {
        const { _id } = this.props.invoiceObj;
        const res = await Request.getInvoiceDetail(_id);
        if(!res.error) {
            this.setState({generatedInvoice: res.doc});
            let formData = {
                emailTo: res.doc.invoiceToEmail,
                emailFrom: (res.doc.companyDetail && res.doc.companyDetail.companyEmail ? res.doc.companyDetail.companyEmail : '')
            };
            this.setState({formData});
        }
    }

    componentWillMount() {
        this.loadInvoiceDetail();
    }

    async componentDidMount() {
        this.loadInvoiceFollowUps();
        this.loadSmsTemplate()
        let params = {
            results:10000,
            count:10000
        }
        let response = await Request.getFollowUpTypes(params)
        let followUpObject = []
        _.each(response.data, (followUp)=>{
            followUpObject.push({id:followUp.name, display:followUp.name})
        })
        this.setState({followUpObject})
    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }
    renderStatus = (val) => {
        if (val === 'Didn\'t Pick up Call') {
            return <div className={styles.Fit2Apply}>{val.toUpperCase()}</div>
        }

        if (val === 'Out Of town') {
            return <div className={styles.LukeWarm}>{val.toUpperCase()}</div>
        }

        if (val === 'Not Interested') {
            return <div className={styles.Potential}>{val.toUpperCase()}</div>
        }

        if (val === 'Busy, Call Later') {
            return <div className={styles.dead}>{val.toUpperCase()}</div>
        }

        if (val === 'Cold') {
            return <div className={styles.Cold}>{val.toUpperCase()}</div>
        }
        if (val === 'Active') {
            return <div className={styles.Cold}>{val.toUpperCase()}</div>
        }
    }

    loadInvoiceFollowUps = async () => {
        this.setState({loading: true})
        let response = await Request.loadInvoiceFollowUps({invoiceId: this.props.invoiceObj._id})               

        if (response) {
            this.setState({arr: response.data})
        }
        this.setState({loading: false})
    }

    showChildrenDrawer = () => {
        this.setState({
            childrenDrawer: true
        })
        setTimeout(() => {
            this.props.form.setFieldsValue(this.state.formData);
        },1000)
    }

    onChildrenDrawerClose = () => {
        this.setState({
            childrenDrawer: false
        })
    }

    handleSubmit = e => {
        const {dispatch, form} = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)
                values._id = this.props.invoiceObj._id;
                values.invoiceToName = this.props.invoiceObj.invoiceToName;
                dispatch(showLoader());
                let x = await Request.addInvoiceFollowUp(values)

                dispatch(hideLoader())

                if (!x.error) {
                    notification.success({
                        message: 'Success',
                        description: x.message
                    })
                    form.setFieldsValue({
                        followUpDate: '',
                        detail: '',
                        followUpType: '',
                    });

                    this.loadInvoiceFollowUps()
                    this.onChildrenDrawerClose()
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.message
                    })
                }
            }
        })
    }
    
    loadSmsTemplate = async () => {
        let templateArr = await Request.getTemplatesForCommunication('InvoiceEmail')
        this.setState({templateArr})
    }

    render() {
        const {
            form: {getFieldDecorator}
        } = this.props
        let {templateArr} = this.state;
        const inputTypes = [
            {
                tabTitle: 'Add Follow Up',
                fields: [
                    {
                        label: 'Next Follow Up Date',
                        key: 'followUpDate',
                        type: 'date',
                        required: true
                    },
                    {
                        label: 'Follow Up',
                        key: 'detail',
                        type: 'textArea',
                        rows: 10,
                        required: true
                    },
                    {
                        label: 'Follow Up Out Come',
                        key: 'followUpType',
                        type: 'select',
                        required: true,
                        options: this.state.followUpObject,
                        placeholder: 'Select followUp Type',
                        onChange: v => {
                            this.props.form.setFieldsValue({
                                followUpType: v
                            })
                        }
                    },
                    // {
                    //     label: 'From',
                    //     key: 'emailFrom',
                    //     required: true
                    // },
                    // {
                    //     label: 'To',
                    //     key: 'emailTo',
                    //     required: true
                    // },
                    // {
                    //     label: 'Choose Template',
                    //     key: 'templateId',
                    //     type: 'select',
                    //     showSearch: true,
                    //     required: true,
                    //     allowClear: true,
                    //     width: 500,
                    //     keyAccessor: x => x.templateData,
                    //     valueAccessor: x => x.templateName,
                    //     disabled: false,
                    //     options: templateArr ? templateArr : [],
                    //     onChange: (v, index) => {
                    //         let emailSubject = templateArr[index.key] != undefined ? templateArr[index.key].emailSubject : '';
                    //         this.props.form.setFieldsValue({templateId: v})
                    //         this.props.form.setFieldsValue({subject: emailSubject})
                    //         this.props.form.setFieldsValue({template: v})
                    //     }
                    // },
                    // {
                    //     label: 'Subject ',
                    //     key: 'subject',
                    //     required: true
                    // },
                    // {
                    //     label: 'Template ',
                    //     key: 'template',
                    //     required: true,
                    //     type: 'editor'
                    // }
                ]
            }
        ];
        
        const column = [
            {
                title: 'Follow Up',
                key: 'detail',
                dataIndex: 'detail',
                render: (val, record) => {
                    return (
                        <div>
                            <div style={{color: 'green'}}>
                                Follow Up Date : {moment(record.followUpDate).format('lll')}<br/>
                                Created Date : {moment(record.entryDate).format('lll')}
                                <div style={{color: 'orange', float: 'right'}}>
                                    {' '}
                                    By ({record.assignByName})
                                </div>
                            </div>
                            <div>{val}</div>
                        </div>
                    )
                }
            },
            {
                title: 'Follow Up Out Come',
                key: 'followUpType',
                dataIndex: 'followUpType',
                render: (val, record) => {
                    return this.renderStatus(val)
                }
            }
        ]
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Follow Up of ({this.props.invoiceObj.invoiceToName})

                            <RightsWrapper myRight={'FollowUps.add'}>
                                <button onClick={this.showChildrenDrawer} style={{float: 'right', marginRight: 50}}>
                                    <Icon type={'plus'}/> Add New Follow Up
                                </button>
                            </RightsWrapper>
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={this.state.visible}>
                <Card>
                    <Table
                        showHeader={false}
                        dataSource={this.state.arr}
                        columns={column}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 50,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                        loading={this.state.loading}
                    />
                </Card>

                <Drawer
                    title={
                        <div>
                            <Icon type={'calendar'}/>
                            Follow Up
                        </div>
                    }
                    width={1000}
                    closable={false}
                    onClose={this.onChildrenDrawerClose}
                    visible={this.state.childrenDrawer}>
                    <Card>
                        <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                            {inputTypes.map((itype, key) => {
                                return (
                                    <div key={key}>
                                        <GetAllFormFields
                                            inputSchema={inputTypes[key]}
                                            getFieldDecorator={getFieldDecorator}
                                        />
                                    </div>
                                )
                            })}

                            <Row>
                                <Col span={8}/>
                                <Col span={8}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{marginBottom: 10}}
                                        loading={this.props.loading}>
                                        SAVE
                                    </Button>
                                </Col>
                                <Col span={8}/>
                            </Row>
                        </Form>
                    </Card>
                </Drawer>
            </Drawer>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(listInvoiceFollowUp)
